import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateCompanyDockActions } from "store/ducks/settings/company-docks";

export function* updateCompanyDockRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/company-docks/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateCompanyDockActions.success(data));
    notify("success", "Doca atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateCompanyDockActions.failure(errorMessage));
  }
}
